// An arctic fox, modelled facing +X: a compact white body, short muzzle,
// rounded ears and a thick bushy tail. Ported 1:1 from age-of-mcp's classic
// arctic-fox.ts, restoring its leg loop + body/head/muzzle/ear/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.045, 0.02], [0.045, -0.02], [-0.045, 0.02], [-0.045, -0.02]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.007, 0.006, 0.058, 4),
      color: "#dfe4e8", position: [x!, 0.029, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.036, 0), color: "#f2f6f9",
      position: [0, 0.058, 0], scale: [1.6, 1, 0.95] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.025, 0), color: "#ffffff",
      position: [0.066, 0.07, 0] },                                  // head
    { geometry: new THREE.ConeGeometry(0.01, 0.022, 4), color: "#f2f6f9",
      position: [0.088, 0.066, 0], rotation: [0, 0, -Math.PI / 2] },   // muzzle
    { geometry: new THREE.ConeGeometry(0.009, 0.018, 4), color: "#e2e8ec",
      position: [0.06, 0.094, 0.014] },                             // round ear
    { geometry: new THREE.ConeGeometry(0.009, 0.018, 4), color: "#e2e8ec",
      position: [0.06, 0.094, -0.014] },
    { geometry: new THREE.CylinderGeometry(0.012, 0.024, 0.06, 5), color: "#ffffff",
      position: [-0.075, 0.06, 0], rotation: [0, 0, 0.9] },          // bushy tail
  );
  return parts;
}

export const arcticFox = defineModel({
  id: "arctic-fox",
  batchId: "standard",
  name: "Arctic fox",
  tags: ["creature","arctic","fox","low-poly","age-of-mcp","classic"],
  summary: "Low-poly arctic fox.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => partsFor(),
  animations: [],
});
